import streamToArray from "../utils/streamToArray";

import getAccessToken from "./getAccessToken";

import type { MetricsQuery } from "../resources/types";

const getMetrics = async <T>(chorusURL: string, query: MetricsQuery) => {
  const endpoint = `${chorusURL}/v1/metrics/query`;
  const accessToken = await getAccessToken();

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken.access_token}`
    },
    body: JSON.stringify(query)
  });
  if (!response.ok) {
    const json = await response.json();
    throw json;
  }

  return streamToArray<T>(response.body);
};

export default getMetrics;
